import store from "../redux/index";
import WebIM from "../utils/WebIM";
import AppDB from "../utils/AppDB";
import MessageActions from "../redux/message";
import SessionActions from "../redux/session";
import GlobalPropsActions from "../redux/globalProps";
import ThreadActions from "../redux/thread";
import uikit_store from "../redux/index";
export default function createlistener(props) {
  WebIM.conn.addEventHandler('EaseChat', {
    onConnected: function onConnected(msg) {
      // init DB
      AppDB.init(WebIM.conn.context.userId); // get session list

      store.dispatch(SessionActions.getSessionList(WebIM.conn.context.userId));
      var options = {
        appKey: WebIM.conn.context.appKey,
        username: WebIM.conn.context.userId
      };
      store.dispatch(SessionActions.getJoinedGroupList());
      store.dispatch(GlobalPropsActions.saveGlobalProps(options));
      props.successLoginCallback && props.successLoginCallback({
        isLogin: true
      });
    },
    onTextMessage: function onTextMessage(message) {
      console.log("onTextMessage", message);
      var chatType = message.chatType,
          from = message.from,
          to = message.to;
      var sessionId = chatType === "singleChat" ? from : to;
      store.dispatch(MessageActions.addMessage(message, "txt"));
      store.dispatch(SessionActions.topSession(sessionId, chatType, message));
    },
    onFileMessage: function onFileMessage(message) {
      console.log("onFileMessage", message);
      store.dispatch(MessageActions.addMessage(message, "file"));
    },
    onVideoMessage: function onVideoMessage(message) {
      console.log("onVideoMessage", message);
      store.dispatch(MessageActions.addMessage(message, "video"));
    },
    onImageMessage: function onImageMessage(message) {
      console.log("onImageMessage", message);
      var chatType = message.chatType,
          from = message.from,
          to = message.to;
      var sessionId = chatType === "singleChat" ? from : to;
      store.dispatch(MessageActions.addMessage(message, "img"));
      store.dispatch(SessionActions.topSession(sessionId, chatType, message));
    },
    onAudioMessage: function onAudioMessage(message) {
      console.log("onAudioMessage", message);
      var chatType = message.chatType,
          from = message.from,
          to = message.to;
      var sessionId = chatType === "singleChat" ? from : to;
      store.dispatch(MessageActions.addAudioMessage(message, "audio"));
    },
    onRecallMessage: function onRecallMessage(message) {
      // When log in, have received the Recall message before get Message from db. so retract after 2 seconds
      if (!uikit_store.getState().message.byId[message.mid]) {
        setTimeout(function () {
          store.dispatch(MessageActions.deleteMessage(message.mid, message.to, message.chatType));
        }, 2000);
        return;
      }

      store.dispatch(MessageActions.deleteMessage(message.mid, message.to, message.chatType));
    },
    // The other has read the message
    onReadMessage: function onReadMessage(message) {
      console.log("onReadMessage", message);
      store.dispatch(MessageActions.updateMessageStatus(message, "read"));
    },
    onReceivedMessage: function onReceivedMessage(message) {
      console.log("updateMessageMid", message);
      var id = message.id,
          mid = message.mid,
          to = message.to;
      store.dispatch(MessageActions.updateMessageMid(id, mid, to));
    },
    onDeliveredMessage: function onDeliveredMessage(message) {
      store.dispatch(MessageActions.updateMessageStatus(message, "received"));
    },
    onPresence: function onPresence(msg) {},
    onError: function onError(err) {
      console.log("error");
      console.error(err);
      props.failCallback && props.failCallback(err);
    },
    onClosed: function onClosed(msg) {
      console.warn("onClosed", msg);
    },
    onDisconnected: function onDisconnected() {
      AppDB.db = undefined;
      store.dispatch(GlobalPropsActions.logout());
    },
    onGroupChange: function onGroupChange(event) {
      console.log("onGroupChange", event);

      if (event.type === 'direct_joined') {
        store.dispatch(SessionActions.getJoinedGroupList());
      } else if (event.type === 'joinPublicGroupSuccess') {
        var joinedGroup = store.getState().session.joinedGroups;
        var result = joinedGroup.find(function (item) {
          item.groupid === event.gid;
        });

        if (!result) {
          store.dispatch(SessionActions.getJoinedGroupList());
        }
      }

      if (event.type === 'addAdmin' || event.type === 'removeAdmin' || event.type === 'changeOwner') {
        var _uikit_store$getState = uikit_store.getState().global.globalProps,
            chatType = _uikit_store$getState.chatType,
            to = _uikit_store$getState.to;

        if (chatType === 'groupChat' && to === event.gid) {
          dispatch(ThreadActions.getCurrentGroupRole({
            chatType: chatType,
            to: to
          }));
        }
      }
    },
    onChatroomChange: function onChatroomChange(event) {
      var type = event.type;

      if (type === "memberJoinChatRoomSuccess") {
        store.dispatch(MessageActions.addNotify(event, "chatRoom"));
      }
    },
    onContactDeleted: function onContactDeleted(msg) {
      store.dispatch(MessageActions.clearMessage("singleChat", msg.from));
      store.dispatch(SessionActions.deleteSession(msg.from));
      store.dispatch(GlobalPropsActions.setGlobalProps({
        to: null
      }));
    },
    onReactionChange: function onReactionChange(message) {
      console.log("onReactionChange", message);
      store.dispatch(MessageActions.updateReaction(message));
    },
    //thread notify
    onChatThreadChange: function onChatThreadChange(msg) {
      console.log("====thread change:", msg);
      store.dispatch(ThreadActions.updateThreadInfo(msg));
    },
    onMultiDeviceEvent: function onMultiDeviceEvent(msg) {
      console.log("====thread mutiDeviceEvent：", msg);
      store.dispatch(ThreadActions.updateMultiDeviceEvent(msg));
    },
    onReactionMessage: function onReactionMessage(message) {
      console.log("onReactionMessage", message);
    }
  });
}